import validate from "/home/vsts/work/1/s/UI/mycim-app/node_modules/nuxt/dist/pages/runtime/validate.mjs";
import auth_45global from "/home/vsts/work/1/s/UI/mycim-app/middleware/auth.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global
]
export const namedMiddleware = {}